// URL evidence only: never infer provider metadata or a file's MIME type from an ID.
export function parseGoogleDocument(value) {
  if (typeof value !== "string" || value.trim().length > 2048 || /[\\\u0000-\u001f\u007f]/.test(value)) return null;
  let u;
  try { u = new URL(value.trim()); } catch { return null; }
  if (u.protocol !== "https:" || !["drive.google.com", "docs.google.com"].includes(u.hostname)
      || u.username || u.password || u.port) return null;
  const id = "[A-Za-z0-9_-]+";
  const office = new RegExp(`^/(document|spreadsheets|presentation)/(?:u/\\d+/)?d/(${id})(?:/|$)`).exec(u.pathname);
  const file = new RegExp(`^/file/(?:u/\\d+/)?d/(${id})(?:/|$)`).exec(u.pathname);
  const queryId = /^\/(?:open|uc)\/?$/.test(u.pathname) && /^[A-Za-z0-9_-]+$/.test(u.searchParams.get("id") || "")
    ? u.searchParams.get("id") : null;
  const title = (u.searchParams.get("title") || u.searchParams.get("name") || "").trim().slice(0, 240);
  let type = "other", previewUrl = null;
  if (u.hostname === "docs.google.com" && office) {
    type = { document: "doc", spreadsheets: "sheet", presentation: "slide" }[office[1]];
    // Published /d/e/... links use a different identifier/permission contract.
    // Do not accidentally treat the literal "e" as a private document ID.
    if (office[2] !== "e" || !/\/d\/e\//.test(u.pathname)) {
      previewUrl = `https://docs.google.com/${office[1]}/d/${office[2]}/preview`;
    }
  } else if (u.hostname === "drive.google.com" && (file || queryId)) {
    previewUrl = `https://drive.google.com/file/d/${file?.[1] || queryId}/preview`;
    // A named PDF in the URL is evidence; an opaque file ID is not.
    if (/\.pdf$/i.test(title)) type = "pdf";
  }
  if (previewUrl && u.searchParams.has("resourcekey")) {
    const key = u.searchParams.get("resourcekey");
    if (/^[A-Za-z0-9_-]+$/.test(key)) previewUrl += `?resourcekey=${encodeURIComponent(key)}`;
  }
  return { url: u.href, type, previewUrl, title };
}
